import { render, staticRenderFns } from "./TablesWindow.vue?vue&type=template&id=2d9cffd8"
import script from "./TablesWindow.vue?vue&type=script&lang=js"
export * from "./TablesWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports